import { logger } from '@tuic/logger';
import { cache } from 'react';

import { Account } from '../../index';

export const getManifest = async (
  idToken: string,
  mpi: number,
): Promise<Account.ManifestFeed | null> => {
  const { data, error } = await Account.getManifest({
    path: { mpi },
    auth: idToken,
  });

  if (data) return data;

  logger.error(`Fetching manifest for MPI "${mpi}" failed.`);
  logger.error(error);

  return null;
};

export const memoizedGetManifest: typeof getManifest = cache(getManifest);

export const storeManifest = async (
  idToken: string,
  mpi: number,
  body: Account.ManifestDetail,
): Promise<{
  data?: Account.ManifestFeed;
  status?: number;
  error?: unknown;
}> => {
  const { data, error, response } = await Account.storeManifest({
    path: { mpi },
    body,
    auth: idToken,
  });

  if (data) return { data };

  return { error, status: response.status };
};
